import React from 'react';

const addonHeading = (props) => (
    <h3 className={`u-fontWeightRegular u-textColorDark u-fontSize16 ${props.active ? 'u-fontWeightMedium u-textColorDark' : null} `}>{props.children}</h3>
);

export default addonHeading;


// WEBPACK FOOTER //
// ./src/components/Addons/AddonsTypography/AddonHeading/AddonHeading.js